import { ElementRef, HostListener, Directive, OnInit, Input } from '@angular/core';

@Directive({
    selector: 'input[elastic-input]',
})
export class ElasticInputDirective implements OnInit {

    public wrapper: HTMLElement;
    public mirror: HTMLElement;

    @HostListener('input', ['$event.target'])
    @Input() public elasticInputMaxWidth: any = -1;

    constructor(
        private element: ElementRef,
    ) {}

    public onInput(): void {
        this.update();
    }

    public ngOnInit(): void {
        this.wrapper = document.createElement('div');
        this.wrapper.style.position = 'fixed';
        this.wrapper.style.top = '-999px';
        this.wrapper.style.left = '0';

        document.body.appendChild(this.wrapper);

        this.mirror = document.createElement('span');
        this.mirror.style.whiteSpace = 'pre';

        this.setMirrorStyle(this.mirror, this.element.nativeElement);

        this.wrapper.appendChild(this.mirror);

        this.update();
    }

    public ngAfterContentChecked(): void {
        this.update();
    }

    public ngOnDestroy(): void {
        this.mirror.remove();
        this.wrapper.remove();
    }

    public setMirrorStyle(mirror: HTMLElement, element: HTMLElement) {
        const style = window.getComputedStyle(element);

        ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle',
        'letterSpacing', 'textTransform', 'wordSpacing'].forEach((value) => {
            mirror.style[value] = style[value];
        });

        mirror.style.paddingLeft = style.textIndent;

        if (style.boxSizing === 'border-box') {
            ['paddingLeft', 'paddingRight', 'borderLeftStyle', 'borderLeftWidth',
            'borderRightStyle', 'borderRightWidth'].forEach((value) => {
                mirror.style[value] = style[value];
            });
        } else if (style.boxSizing === 'padding-box') {
            ['paddingLeft', 'paddingRight'].forEach((value) => {
                mirror.style[value] = style[value];
            });
        }
    }

    public update() {
        this.mirror.innerText = this.element.nativeElement.value;
        let width = this.mirror.offsetWidth;
        if (this.elasticInputMaxWidth > -1) {
            width = width > this.elasticInputMaxWidth ? this.elasticInputMaxWidth : width;
        }

        this.element.nativeElement.style.width = `${width}px`;
    }
}
